export default{
    getByteLen:(val,max)=>{
        let len = 0;
        for (let i = 0; i < val.length; i++) {
            let a = val.charAt(i);
            if (a.match(/[^\x00-\xff]/ig) != null) {
              len += 3;
            }
            else {
                len += 1;
            }
            if(max && max <= len){
              return i-1;
            }
        }
        return len;
    },
    filterEmptyStr:(val)=> {
    // 遍历请求对象中的所有键值对
     Object.keys(val).forEach(key => {
    // 如果值为空字符串，则删除该键
    if (val[key] === '') {
        delete val[key];
    }
    return val;
   });
  }
}


// WEBPACK FOOTER //
// ./src/utils/common.js